export function isValidUrl(value) {
  try {
    const url = new URL(value);

    return ["http:", "https:"].includes(url.protocol);
  } catch {
    return false;
  }
}

export function validateCampaign(form) {
  const errors = {};

  if (!form.greeting) {
    errors.greeting = "Please select a greeting.";
  }

  if (!form.type) {
    errors.type = "Please select a campaign type.";
  }

  if (!form.description?.trim()) {
    errors.description = "Description is required.";
  } else if (form.description.trim().length > 180) {
    errors.description = "Description must not exceed 180 characters.";
  }

  if (!form.start_date) {
    errors.start_date = "Start date is required.";
  } else if (new Date(form.start_date) < new Date()) {
    errors.start_date = "Start date cannot be in the past.";
  }

  if (!form.end_date) {
    errors.end_date = "End date is required.";
  }

  if (form.message && form.message.trim().length > 50) {
    errors.message = "Message must not exceed 50 characters.";
  }

  if (
    form.start_date &&
    form.end_date &&
    new Date(form.end_date) <= new Date(form.start_date)
  ) {
    errors.end_date = "End date must be after the start date.";
  }

  if (!form.color_code) {
    errors.color_code = "Please select a campaign color.";
  }

  /*
   * Donation
   */
  if (form.type === "Donation") {
    if (form.amount !== null &&form.amount !== undefined &&form.amount !== "") {
      if (Number(form.amount) < 500) {
        errors.amount = "Donation amount must be at least 500.";
      }
    }
  }

  /*
   * Non-donation
   */
  if (form.type && form.type !== "Donation") {
    if (!form.action_url?.trim()) {
      errors.action_url = "Action URL is required.";
    } else if (!isValidUrl(form.action_url)) {
      errors.action_url = "Please enter a valid URL.";
    }
  }

  return errors;
}

export function isCampaignValid(form) {
  return Object.keys(validateCampaign(form)).length === 0;
}
